export default {"src":"/_next/static/media/doc-clock.4e7abde0.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};